import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { CustomPropTypes } from '@beef/react';

/**
 * HOC that created domNodeRef and controlsRef - both of which are mandatory props for the ScrollContainer
 * This HOC can be omitted if domNodeRef and controlsRef are passed manually
 */
export default function withDefaultRefs(WrappedComponent) {
  var WithDefaultRefs = function WithDefaultRefs(props) {
    var domNodeRef = React.useRef();
    var controlsRef = React.useRef();
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      controlsRef: controlsRef,
      domNodeRef: domNodeRef
    }, props, {
      "data-t-id": "ScrollContainerV2-enhancers"
    }));
  };
  WithDefaultRefs.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, WrappedComponent.propTypes), {}, {
    /** these refs are made optional */
    domNodeRef: CustomPropTypes.newRef,
    controlsRef: CustomPropTypes.newRef
  }) : {};
  if (process.env.NODE_ENV !== 'production') {
    WithDefaultRefs.displayName = WrappedComponent.displayName;
  }
  return WithDefaultRefs;
}